import dynamic from 'next/dynamic';
const Language = dynamic(() => import('./languageModal'), { ssr: false });
export default Language;
